import styled from '@emotion/styled';
import React from 'react';
import { SliceWrapper } from './SliceWrapper';

interface IProps {
  children: React.ReactNode;
  cards: React.ReactNode;
  isArticle: boolean;
}

const CardWrap = styled.div``;

export const TextWithRelated = ({ children, cards, isArticle }: IProps) => {
  return (
    <SliceWrapper
      left={children}
      right={<CardWrap>{cards}</CardWrap>}
      isArticle={isArticle}
    />
  );
};
